import * as types from './types'
import http from '../../utils/http'
// import router from '../../router/index'
import Vue from 'vue'

const vue = new Vue()

const state = {
  sliderToggle: true,
  editMask: 0
}

const actions = {
  [types.SLIDERTOGGLE] (context, params) {
    context.commit(types.SLIDERTOGGLE, params)
  },
  [types.EDITPASSWARD] (context, params) {
    http.fetch('/api/user/updatePwd', params).then(data => {
      context.commit(types.EDITPASSWARD, data)
    })
  }
}

const mutations = {
  [types.SLIDERTOGGLE] (state, data) {
    // console.log(data, 'data')
    state.sliderToggle = data
  },
  [types.EDITPASSWARD] (state, data) {
    console.log(data, '修改密码')
    if (data.code === 200) {
      state.editMask = 1
      vue.$message({
        showClose: true,
        message: '修改成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
    // state.sliderToggle = data
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/toggle/index.js